// API utilities for community stats
// Using environment variable for API URL to hide it from public view
const API_BASE_URL = process.env.REACT_APP_STATS_API_URL || 'https://smite-randimzier-stats.ericjtischendorf.workers.dev';

/**
 * Fetch current community stats
 * @returns {Promise<Object>} - Promise resolving to stats object
 */
export const fetchStats = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/stats`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch stats');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching stats:', error);
    // Return default values if fetch fails
    return {
      godsRolled: 0,
      buildsCreated: 0,
      totalRandomizations: 0
    };
  }
};

/**
 * Increment a specific stat
 * @param {string} type - The stat to increment ('godsRolled', 'buildsCreated', or 'totalRandomizations')
 * @returns {Promise<Object>} - Promise resolving to response object
 */
export const incrementStat = async (type) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/increment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type }),
    });
    
    if (!response.ok) {
      throw new Error('Failed to increment stat');
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Error incrementing ${type}:`, error);
    return { error: error.message };
  }
}; 